import React, { PropsWithChildren } from 'react';

import MuiMenuItem, {
  MenuItemProps as MuiMenuItemProps,
} from '@mui/material/MenuItem';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const MenuItem = withCoreProps<MenuItemProps>(
  ({ children, className, ...props }: PropsWithChildren<MenuItemProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiMenuItem {...props} className={clsxClass}>
        {children}
      </MuiMenuItem>
    );
  },
);

export interface MenuItemProps
  extends Omit<MuiMenuItemProps, 'button'>,
    CoreProps {}
